import { render, staticRenderFns } from "./addChangeHost.vue?vue&type=template&id=cdf69494&"
import script from "./addChangeHost.vue?vue&type=script&lang=js&"
export * from "./addChangeHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports